export default __webpack_public_path__ + "static/media/rectangle.261ce508.wav";